import React, { useState } from 'react';
import { Button } from './Button';
import './TermsModal.css';

interface TermsModalProps {
  isOpen: boolean;
  onAccept: () => Promise<void>;
  isLoading?: boolean;
}

export const TermsModal: React.FC<TermsModalProps> = ({ isOpen, onAccept, isLoading }) => {
  const [isAccepting, setIsAccepting] = useState(false);

  if (!isOpen) return null;

  const handleAccept = async () => {
    setIsAccepting(true);
    try {
      await onAccept();
    } finally {
      setIsAccepting(false);
    }
  };

  return (
    <div className="terms-modal-overlay forced">
      <div className="terms-modal forced">
        <div className="terms-modal-header">
          <h2>📋 Terms & Conditions</h2>
        </div>
        <div className="terms-modal-content">
          <div className="terms-warning">
            <span className="terms-warning-icon">⚠️</span>
            <strong>Important Medical Disclaimer</strong>
          </div>
          
          <p>Welcome to ElevatePhysique AI! Before you continue, please read and accept our Terms & Conditions:</p>
          
          <ol className="terms-list">
            <li>
              <strong>AI Limitations:</strong> This application uses artificial intelligence to provide health and fitness information. AI systems can make mistakes and may provide inaccurate, incomplete, or inappropriate recommendations.
            </li>
            <li>
              <strong>Not Medical Advice:</strong> The information provided by ElevatePhysique AI is for informational purposes only and should NOT be considered as medical advice, diagnosis, or treatment recommendations.
            </li>
            <li>
              <strong>Consult Healthcare Professionals:</strong> Always consult with a qualified, certified healthcare professional (doctor, physician, registered dietitian, certified personal trainer, etc.) before starting any new exercise program, diet plan, or making health-related decisions.
            </li>
            <li>
              <strong>Emergency Situations:</strong> In case of a medical emergency, call your local emergency services immediately. Do not rely on this application for emergency medical guidance.
            </li>
            <li>
              <strong>Personal Responsibility:</strong> You are solely responsible for any actions you take based on the information provided by this application. Use the information at your own risk.
            </li>
            <li>
              <strong>Application Under Development:</strong> This application is currently under development. Features, accuracy, and reliability may vary and improve over time.
            </li>
          </ol>

          <div className="terms-highlight">
            <strong>🏥 Best Practice:</strong> Always verify any health or fitness advice with a real, certified healthcare professional before implementing changes to your lifestyle.
          </div>
        </div>
        <div className="terms-modal-footer">
          <Button
            variant="primary"
            onClick={handleAccept}
            isLoading={isAccepting || isLoading}
            fullWidth
          >
            I Understand & Accept Terms
          </Button>
        </div>
      </div>
    </div>
  );
};
